import { InstallationPredictedStatusEnum } from "./InstallationPredictedStatusEnum";

export class Prediction {
    machineSerialNumber: string;
    machineInstallationName: string;
    dateTime: Date;
    confidence: number = 0;
    status: InstallationPredictedStatusEnum;
    importantFeature: Map<string, number>;

    constructor() {
        this.machineSerialNumber = null;
        this.machineInstallationName = null;
        this.dateTime = null;
        this.status = null;
    }

    public parse(obj: any) {
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.DateTime) this.dateTime = new Date(obj.DateTime);
        if (obj.Confidence) this.confidence = obj.Confidence;
        if (Object.values(InstallationPredictedStatusEnum).includes(obj.Status)) this.status = obj.Status;
        if (obj.ImportantFeature) {
            let jsonObj = JSON.parse(obj.ImportantFeature);
            this.importantFeature = new Map<string, number>();
            for (let key in jsonObj) this.importantFeature.set(key, jsonObj[key]);
        }
    }
}
